
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'CaixaCliente',
    props: {
        // URL já resolvida da imagem (ver uteis/conteudo.urlDaImagem)
        Imagem: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: "80px"
        },
        Nome: {
            type: String,
            default: "Cliente LimaTec"
        }
    }
  });
